import React from "react";
import { useSubscriptionFeature } from "../../../hooks/useSubscriptionFeature";
import SubscriptionUpgradePage from "./SubscriptionUpgradePage";

/**
 * Renders children if the subscription feature is enabled,
 * otherwise shows an upgrade prompt.
 *
 * @param {string} featureKey - Key from SUBSCRIPTION_FEATURES
 * @param {string} featureName - Human-readable name for the upgrade page
 * @param {React.ReactNode} [fallback] - Optional custom fallback instead of default upgrade page
 * @param {React.ReactNode} children
 */
const FeatureGate = ({ featureKey, featureName, fallback, children }) => {
  const { enabled, isLoading } = useSubscriptionFeature(featureKey);

  if (import.meta.env.VITE_DISABLE_FEATURE_GATES === "true") return children;
  if (isLoading) return null;
  if (enabled) return children;
  return fallback || <SubscriptionUpgradePage featureName={featureName} />;
};

export default FeatureGate;
